export const SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY =
  // eslint-disable-next-line no-process-env
  process.env.NODE_ENV === 'production' ? '29141061979865099' : '29141061880280959';
